import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {isCoreObjectId} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {assert} from 'Asserts';
import {isNodeTesting} from 'lib/Browser';
import {SYSTEM_CATEGORY_EXTERNAL_NAME} from 'schemas/schema-interface/util/schemaFieldsetName';
import getSchemaInterfaceType from 'schemas/schema-interface/v2/getSchemaInterfaceType';
import {assertNever} from 'util/Types';

export default function getSchemaInterfaceMetadata(interfaceId: string): string | null {
  // TODO(BNCH-92241): Remove this and always crash once we generate valid ids in GQL fixtures / mocks
  if (!isCoreObjectId(interfaceId)) {
    assert(isNodeTesting, 'Should not see invalid interface IDs outside of tests');
    return null;
  }
  const interfaceType = getSchemaInterfaceType(interfaceId);
  switch (interfaceType) {
    case DomainGraphType.CUSTOM_SCHEMA_INTERFACE:
      return null; // This is the default, so no special label is necessary
    case DomainGraphType.STATIC_SCHEMA_INTERFACE:
      return SYSTEM_CATEGORY_EXTERNAL_NAME;
    default:
      throw Error(`Invalid interface type: ${assertNever(interfaceType)}`);
  }
}
